/* The Daily Cart v5.1.2 */
(function(){
  var d=document;
  function idle(f){if('requestIdleCallback' in window)requestIdleCallback(f,{timeout:2500});else setTimeout(f,800);}
  function hh(){var h=d.querySelector('.dc-header');if(h){d.documentElement.style.setProperty('--dc-hh',Math.round(h.getBoundingClientRect().height)+'px');}}
  hh();addEventListener('resize',hh);addEventListener('load',hh);
  var orig='';try{orig=performance.getEntriesByType('navigation')[0].name||'';}catch(e){}
  var hadVariant=/[?&]variant=/.test(orig);

  /* 8. the editor hint "Move, zoom & rotate" uses the deeper terracotta */
  function deep(){var s=d.querySelectorAll('span');for(var i=0;i<s.length;i++){if(!s[i].children.length&&/^Move, zoom/.test(s[i].textContent.trim())){s[i].classList.add('dc-v427-deep');}}}
  deep();setTimeout(deep,1500);

  /* 34. product photos: load every gallery picture once the page is idle so variant swaps are instant */
  function warm(){d.querySelectorAll('.dc-gallery__slide img[loading="lazy"]').forEach(function(i){i.loading='eager';});}
  if(d.querySelector('.dc-gallery__slide')){if(d.readyState==='complete')idle(warm);else addEventListener('load',function(){idle(warm);});}

  /* 36. gold line icons instead of emoji on the Printify upload buttons */
  var CAM=/^[\s️]*📸[\s️]*/, PEN=/^[\s️]*✏[\s️]*/;
  function icons(){
    d.querySelectorAll('.personalize-button').forEach(function(b){
      for(var n=b.firstChild;n;n=n.nextSibling){
        if(n.nodeType!==3)continue;
        var t=n.nodeValue;
        if(CAM.test(t)){n.nodeValue=t.replace(CAM,'');b.classList.add('dc-v427-cam');b.classList.remove('dc-v427-pen');}
        else if(PEN.test(t)){n.nodeValue=t.replace(PEN,'');b.classList.add('dc-v427-pen');b.classList.remove('dc-v427-cam');}
        else if(/✓/.test(t)){b.classList.remove('dc-v427-cam');b.classList.remove('dc-v427-pen');}
        break;
      }
    });
  }
  icons();setTimeout(icons,600);setTimeout(icons,1800);
  if('MutationObserver' in window){var tm=null;new MutationObserver(function(){clearTimeout(tm);tm=setTimeout(icons,60);}).observe(d.body,{childList:true,subtree:true,characterData:true});}

  /* 29. Pet ID tag: the photos show the blue bone, so the page opens on Bone + Blue (same as the photo) and says that the tag is made in the chosen shape and color */
  if(/pet-id-tag/.test(location.pathname)){
    var pickOpt=function(v){var r=d.querySelectorAll('input[type=radio]');for(var i=0;i<r.length;i++){if(r[i].value===v&&!r[i].checked&&!r[i].disabled){(r[i].closest('label')||r[i]).click();return;}}};
    if(!hadVariant){setTimeout(function(){pickOpt('Bone');pickOpt('Blue');},350);}
    var opts=d.querySelectorAll('.dc-opt');
    if(opts.length&&!d.querySelector('.dc-v427-note')){var p=d.createElement('p');p.className='dc-v427-note';p.textContent='Photos show the blue bone. Your tag is made in the shape and color you pick, and engraved with the name and number you type next.';opts[opts.length-1].parentNode.insertBefore(p,opts[opts.length-1].nextSibling);}
  }

  /* 21. every product page opens on its first (lead) photo, not the first variant's own picture, unless the shopper arrived with a chosen variant or interacts first */
  (function(){
    var th=d.querySelectorAll('.dc-gallery__thumb');
    if(!th.length||hadVariant)return;
    var touched=false;
    ['pointerdown','keydown','touchstart'].forEach(function(e){d.addEventListener(e,function(){touched=true;},{once:true,passive:true});});
    function fix(){
      if(touched)return;
      var cur=-1,i;for(i=0;i<th.length;i++){if(th[i].classList.contains('is-active')){cur=i;break;}}
      if(cur>0){th[0].click();}
    }
    setTimeout(fix,600);setTimeout(fix,1400);
  })();

  /* 45. no real photo = hard stop: the design pop-up cannot add to cart until the shopper ticks "my own photo is showing" (reset on every new save); Add to cart reopens the pop-up until then.
     v5.0.4: green look, same as the engraving confirm box.
     v5.1.2: the tick box is inside the pinned Add to cart button itself (one button: tap to tick, tap again to add), so it is always on screen.
     v5.1.2 (fix 3): the "Make it a set?" pictures come from each product's own photo. Printify's script swaps the biggest picture on the page for the design
     preview when a design is saved, and that could be a hidden add-on picture (seen on the mug: the blanket tile showed the mug camera picture).
     "Your mug" row shows the mug's product photo. */
  (function(){
    function init(){
      var root=d.querySelector('[data-dc-product]'),lb=d.querySelector('[data-dc-pz-lb]');
      if(!root||!lb)return;
      var ok=false,saved=false,tq=0;
      var st=d.createElement('style');
      st.textContent='.dc-p2[data-step="1"] .dc-p2__go{display:flex !important;align-items:center;justify-content:flex-start;text-align:left;gap:12px;line-height:1.25;min-height:60px;padding-left:18px;padding-right:18px;-webkit-tap-highlight-color:transparent}'+
        '.dc-p2[data-step="1"] .dc-p2__go::before{content:"\\2713";flex:0 0 24px;width:24px;height:24px;box-sizing:border-box;border-radius:7px;border:2px solid #fff;background:#fff;color:#B5562F;font-size:16px;font-weight:900;line-height:20px;text-align:center}'+
        '.dc-v5locked .dc-p2__go{justify-content:flex-start !important;background:#EEF6EE !important;color:#2B1E17 !important;border:2px solid #9CC9A6 !important;box-shadow:none !important;animation:none !important;font-size:0 !important;text-align:left}'+
        '.dc-p2.dc-v5locked[data-step="1"] .dc-p2__go::before{content:"";border-color:#2E5E3A;background:#fff}'+
        '.dc-v5locked .dc-p2__go::after{content:"Tap to confirm: my own photo is showing";font-size:16px;font-weight:800}'+
        '.dc-v5locked .dc-p2__alt{display:block;border:2px solid #E7DCCD;border-radius:99px;padding:12px;text-decoration:none;font-weight:800;color:#fff;min-height:48px}'+
        '@keyframes dcV5Shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}'+
        '.dc-p2[data-step="1"] .dc-p2__go.is-shake{animation:dcV5Shake .4s !important}';
      d.head.appendChild(st);
      function pop(){return lb.querySelector('.dc-p2');}

      /* product photos for the "Make it a set?" step */
      var imgs={},boxes=Array.prototype.slice.call(root.querySelectorAll('[data-dc-match]'));
      function sized(u){if(!u)return '';if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width=160';}
      function pjs(url,key){
        if(!url)return;
        fetch(url.split('?')[0]+'.js',{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;}).then(function(j){
          if(j&&j.featured_image){imgs[key]=sized(j.featured_image);fixImgs();}
        }).catch(function(){});
      }
      if(boxes.length){
        boxes.forEach(function(A,i){pjs(A.getAttribute('data-url'),'t'+i);});
        pjs(location.pathname,'main');
      }
      function setSrc(im,u){if(im&&u&&im.getAttribute('src')!==u){im.removeAttribute('srcset');im.src=u;}}
      function fixImgs(){
        var P=pop();if(!P)return;
        var tl=P.querySelectorAll('.dc-p2t');
        if(tl.length&&tl.length===boxes.length){
          for(var i=0;i<tl.length;i++){
            var bi=boxes[i].querySelector('.dc-match__img img');
            setSrc(tl[i].querySelector('img'),imgs['t'+i]||(bi&&bi.getAttribute('data-original-src'))||'');
          }
        }
        setSrc(P.querySelector('.dc-p2__mine img'),imgs.main||'');
      }

      /* v5.1.2: one button. First tap ticks it ("my own photo is showing"), the button turns into "Looks good - Add to cart" with a tick,
         the next tap adds. A second tap within 0.7 s is ignored so a quick double tap can't confirm and add at once.
         Saving a new design resets it. */
      var tickAt=0;
      function ev(n){try{if(typeof window.clarity==='function')window.clarity('event',n);}catch(x){}}
      function sync(){
        var P=pop();if(!P)return;
        var lock=P.getAttribute('data-step')==='1'&&!ok;
        P.classList.toggle('dc-v5locked',lock);
        var go=P.querySelector('.dc-p2__go');
        if(go){
          if(lock){go.setAttribute('role','checkbox');go.setAttribute('aria-checked','false');go.setAttribute('aria-label','Tap to confirm: my own photo is showing');}
          else{go.removeAttribute('role');go.removeAttribute('aria-checked');go.removeAttribute('aria-label');}
        }
      }
      function ensure(){tq=0;sync();fixImgs();}
      function later(){if(!tq)tq=setTimeout(ensure,0);}
      new MutationObserver(later).observe(lb,{attributes:true,attributeFilter:['style','data-step'],subtree:true,childList:true});
      function stop(e){e.preventDefault();e.stopImmediatePropagation();}
      function warn(P){
        var g=P.querySelector('.dc-p2__go');
        if(g){g.classList.remove('is-shake');void g.offsetWidth;g.classList.add('is-shake');}
      }
      window.addEventListener('message',function(e){
        if(String(e.origin).indexOf('personalize.at')<0)return;
        var m=e.data;try{if(typeof m==='string')m=JSON.parse(m);}catch(x){return;}
        if(m&&m.type==='PERSONALIZATION_APPLIED'){saved=true;ok=false;sync();}
      },true);
      window.addEventListener('click',function(e){
        var t=e.target;if(!t||!t.closest||!saved)return;
        var go=t.closest('.dc-p2__go');
        if(go&&lb.contains(go)){
          var P=pop();if(!P||P.getAttribute('data-step')!=='1')return;
          if(!ok){stop(e);ok=true;tickAt=Date.now();sync();ev('photo_tick_on');return;}
          if(Date.now()-tickAt<700){stop(e);return;}
          return;
        }
        if(ok)return;
        var a=t.closest('[data-dc-atc],[data-dc-sticky-go]');
        if(a&&root.contains(a)){stop(e);lb.style.display='flex';d.body.style.overflow='hidden';setTimeout(function(){ensure();var P=pop();if(P)warn(P);},120);}
      },true);
    }
    if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
  })();
})();
